import { render, staticRenderFns } from "./CreateOrChooseAssetSmallWidget.vue?vue&type=template&id=35f2fba0&"
import script from "./CreateOrChooseAssetSmallWidget.vue?vue&type=script&lang=js&"
export * from "./CreateOrChooseAssetSmallWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports